'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itTableRegistry", function () {
  var registryMap = {};
  var registry = {
    /**
     * Register the table to the registry.
     *
     * @returns {Function} unregistering function
     */
    register: function register(tableId, tableCtrl) {
      if (_.includes(registryMap, tableId)) {
        throw "Table already registered for id " + tableId + ". is there a naming conflict ?";
      }
      registryMap[tableId] = tableCtrl;
      return function () {
        registry.unregister(tableId);
      };
    },
    /**
     * Get API controller for given table
     *
     * @param tableId
     */
    getController: function getController(tableId) {
      return registryMap[tableId];
    },
    /**
     * Unregister given table.
     */
    unregister: function unregister(tableId) {
      delete registryMap[tableId];
    }
  };
  return registry;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itTableRegistry.js
// module id = 2805
// module chunks = 13